module.exports = "/img/whatsapp.png?db491cc0eb05b082bb301af69dcf0702";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/whatsapp.png
// module id = tMUn
// module chunks = 46